import * as yup from "yup";

export const validationSchema = yup.object({
  name: yup.string().required(),
  description: yup.string().required(),
  price: yup.number().min(1).required(),
  weight: yup.number().min(1).required(),
  // height: yup.number().min(1).required(),
  // length: yup.number().min(1).required(),
  // width: yup.number().min(1).required(),
  stock: yup.number().min(0).required(),
  isRare: yup.boolean().required(),
  originName: yup.string().required(),
  versionName: yup.string().required(),
  productTypeName: yup.string().required(),
  originId: yup.number().required(),
  versionsId: yup.number().required(),
  productTypeId: yup.number().required(),
});
